import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { makeStyles } from '@material-ui/core/styles';
import { getFormatedDate } from '../../../../helper';
import { formatToKOrMWithoutDecimal } from '../../../../helper';


const useStyles = makeStyles((_theme) => ({
  chartContainer: {
    position: 'relative',
    overflow: 'hidden',
},
sliderContainer: {
    margin: '20px 0',
    padding: '0 30px',
    position: 'relative',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
},
sliderWrapper: {
    position: 'relative',
    height: '8px',
    display: 'flex',
    alignItems: 'center',
},
slider: {
    WebkitAppearance: 'none',
    width: '100%',
    height: '4px',
    background: '#e0e0e0',
    borderRadius: '2px',
    outline: 'none',
    '&::-webkit-slider-thumb': {
        WebkitAppearance: 'none',
        width: '20px',
        height: '20px',
        background: '#0067A1',
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        '&:hover': {
            transform: 'scale(1.1)',
            background: '#004d80',
        },
        '&:active': {
            transform: 'scale(1)',
        }
    },
},
pageIndicator: {
    position: 'absolute',
    right: '0',
    bottom: '-24px',
    color: '#666',
    fontSize: '0.8rem',
    fontWeight: 400,
    fontFamily: 'system-ui, sans-serif',
    '& span': {
        color: '#0067A1',
        fontWeight: 500,
    }
},
progressTrack: {
    position: 'absolute',
    height: '4px',
    background: '#0067A1',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
},
}));

const BarLineChartIOF = ({ graphData = [], activeTab}) => {
    const classes = useStyles();
    const [borderRadius, setBorderRadius] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    useEffect(() => {
        setCurrentPage(0);
    }, [activeTab]);

    useEffect(() => {
        const handleResize = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 1000) {
            setBorderRadius(2);
        } else if (screenWidth < 1500) {
            setBorderRadius(5);
        } else {
            setBorderRadius(7);
        }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    const totalItems = graphData?.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Data mapping based on `activeTab`
    const yAxisTitle = "# Special Orders";

  const categories = graphData?.map((item) => getFormatedDate(item?.ScenerioRunDate) || 'Unknown Metric');
  const seriesData = [
            {
              name: "# Special Orders ",
              data: graphData?.map((item) => item?.Rush_Special_Orders || 0),
            },
            {
              name: "Special Orders %",
              data: graphData?.map((item) => item?.Percent || 0),
              type: "line"
            },
    ];
        

    // Slice data for current page
    const slicedCategories = categories?.slice(startIndex, endIndex);
    const slicedSeries = seriesData?.map(s => ({
        ...s,
        data: s?.data?.slice(startIndex, endIndex)
    }));

  
    // Chart options
    const options = {
        chart: {
        height: 350,
        type: 'bar',
        stacked: false,
        toolbar: { show: false },
        animations: {
            enabled: true,
            easing: 'easeInOutQuad',
            speed: 600,
            animateGradually: {
            enabled: true,
            delay: 150,
            },
            dynamicAnimation: {
            enabled: true,
            speed: 350,
            },
        },
        },
        plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: "5%",
            borderRadius: borderRadius,
            borderRadiusApplication: 'end',
        },
        },
        dataLabels: { enabled: false },
        stroke: { width: 2 },
        series: slicedSeries,
        colors:['#FFC501', '#EC6FBD'],
        xaxis: {
        categories: slicedCategories,
        title: {
            text: "",
            style: {
            fontSize: '12px',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 500,
            color: '#333',
            },
        },
        },
        yaxis: [{
            title: {
                text: yAxisTitle,
                style: {
                fontSize: '12px',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500,
                color: '#333',
                },
            },
            labels: {
                formatter: (value) => formatToKOrMWithoutDecimal(value), // Ensure no decimals
            },
        }, {
            // Right y-axis for accuracy (percentage)
            opposite: true, // Place the axis on the right side
            title: {
                text: 'Special Orders %',
                style: {
                    fontSize: '12px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 500,
                    color: '#333',
                },
            },
            labels: {
                formatter: (value) => `${value}%`,
            },
        }
        ],
        tooltip: {
        shared: true,
        intersect: false,
        y: [{
            formatter: (val) => val,
            },
            {
                formatter: (val) => `${val?.toFixed(2)}%`,
            },
        ]},
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            markers: {
                width: 12,
                height: 12,
                radius: 10,
                shape: "circle",
            },
        },
        grid: { show: false },
        noData: {
            text: 'No Data Available',
            align: 'center',
            verticalAlign: 'middle',
            style: {
            color: '#404041',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            },
        },
    };

  return (
    <div className="grouped-bar-chart">
      <ReactApexChart options={options} series={slicedSeries} type="bar" height={350} />

      {totalPages > 1 && (
                <div className={classes.sliderContainer}>
                    <div className={classes.sliderWrapper}>
                        <div
                            className={classes.progressTrack}
                            style={{
                                width: `${((currentPage + 1) / totalPages) * 100}%`,
                                opacity: 0.3
                            }}
                        />
                        <input
                            type="range"
                            min="0"
                            max={totalPages - 1}
                            value={currentPage}
                            onChange={(e) => setCurrentPage(parseInt(e.target.value, 10))}
                            className={classes.slider}
                        />
                    </div>
                    <div className={classes.pageIndicator}>
                        <span>{currentPage + 1}</span> / {totalPages}
                    </div>
                </div>
            )}
    </div>
  );
};

export default BarLineChartIOF;